import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Container,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    Typography
} from '@mui/material'
import React from 'react'
import {Helmet} from 'react-helmet'
import {Link} from 'react-router-dom'
import Header from '../Landing/Header'
import {useTranslation} from 'react-i18next';
import logo from '../../assets/images/logo/full.png';
import bg1 from '../../assets/images/background/bg1.jpg';
import {ReactComponent as Plus} from '../../assets/images/icons/svg/1.svg';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';


function generateStructuredData() {
    const questions = [
        {
            question: 'What is X-Money?',
            answer:
                "X-Money is the affiliate program behind warehouse-x.io. Warehouse X is a fast-growing online adult reality show with some of the world's most beautiful models. Warehouse X lets members watch and interact with models living in Warehouse X studio.",
        },
        {
            question: 'What are the program options?',
            answer:
                "Currently, we offer the RevShare program where you get up to 20.00% of what your users spend, for life*! Send sales to https://warehouse-x.io and get paid as the members you referred spend more. The earnings just keep coming, it is a great stable deal. *This rule will apply as long as there is an effective X-Money Services Agreement between you (as Affiliate) and the Company.",
        },
        {
            question: 'How much will I earn?',
            answer: "The potential is limitless and depends totally on you. The more traffic you send, the more money you make.",
        },
        {
            question: 'How will I know how much I have earned?',
            answer: "You will be able to log in to our affiliate area to view real-time stats for your affiliate account.",
        },
        {
            question: 'Where do I start?',
            answer: "Start making money with X-Money in three simple steps:\n\n1. Register with the X-Money affiliate program;\n2. Wait until our support team review your submission and activate your account (you will get a confirmation email);\n3. Start sending traffic;",
        },
        {
            question: 'When do I get paid?',
            answer:
                "Payments are made every Friday for the previous week (from Monday to Sunday). A minimum of $200 must be earned during the period, or the money earned will be paid out when the minimum amount has been met.",
        },
        {
            question: 'Do I need multiple accounts for many websites?',
            answer: "No, you only need one X-Money account. X-Money lets you track signups from all your websites.",
        },
        {
            question: 'Where can I find the referral link?',
            answer: "You'll find it in the Linking Codes section of the X-Money affiliate area. It is marked as Webmaster Referral URL.",
        },
        {
            question: "Didn’t find an answer to my question",
            answer: "No problem! Get in touch with our affiliates support via affiliate@warehouse-x.io",
        },
        {
            question: 'How much will I earn for a signup of a user?',
            answer: "The earnings per user signup vary based on the user's location (tier). Here are the tiers:\n\nTier 1 - $2\nAustralia, Austria, Belgium, Canada, Denmark, Finland, France, Germany, Ireland, Italy, Luxembourg, Netherlands, New Zealand, Norway, Spain, Sweden, Switzerland, United Kingdom, United States of America\n\nTier 2 - $1\nAndorra, Argentina, Bahamas, Belarus, Bolivia, Bosnia and Herzegovina, Brazil, Brunei, Bulgaria, Chile, China, Colombia, Costa Rica, Croatia, Cyprus, Czech Republic, Dominican Republic, Ecuador, Egypt, Estonia, Fiji, Greece, Guyana, Hong Kong, Hungary, Iceland, Indonesia, Israel, Japan, Kazakhstan, Latvia, Lithuania, Macao, Malaysia, Malta, Mexico, Montenegro, Morocco, Nepal, Oman, Panama, Paraguay, Peru, Philippines, Poland, Portugal, Puerto Rico, Qatar, Republic of Korea (South), Romania, Russian Federation, Saudi Arabia, Serbia, Singapore, Slovakia, Slovenia, South Africa, Thailand, Turkey, Ukraine, United Arab Emirates, Uruguay, Vanuatu\n\nTier 3 - $0.5\nAlbania, Algeria, Angola, Armenia, Azerbaijan, Bahrain, Bangladesh, Barbados, Belize, Benin, Botswana, Burkina Faso, Burundi, Cambodia, Cameroon, Cape Verde, Chad, Comoros, Congo, El Salvador, Ethiopia, Gabon, Georgia, Guatemala, Guinea, Haiti, Honduras, India, Iraq, Jamaica, Jordan, Kenya, Kuwait, Kyrgyzstan, Laos, Lebanon, Lesotho, Macedonia, Madagascar, Mali, Mauritania, Mauritius, Moldova, Mongolia, Mozambique, Namibia, Nicaragua, Niger, Nigeria, Pakistan, Senegal, Sri Lanka, Suriname, Swaziland, Tajikistan, Tanzania, Togo, Trinidad and Tobago, Tunisia, Turkmenistan, Uganda, Uzbekistan, Vietnam, Zambia\n\nTier 4 - $0.1\nAfghanistan, Aland Islands, American Samoa, Anguilla, Antigua and Barbuda, Aruba, Bermuda, Bhutan, British Indian Ocean Territory, Brunei Darussalam, Cayman Islands, Central African Republic, Christmas Island, Cocos (Keeling) Islands, Congo, The Democratic Republic of the, Cook Islands, Cote d'Ivoire, Cuba, Curacao, Djibouti, Dominica, Equatorial Guinea, Eritrea, Falkland Islands (Malvinas), Faroe Islands, French Polynesia, French Southern Territories, Gambia, Ghana, Gibraltar, Greenland, Grenada, Guam, Guernsey, Guinea-Bissau, Holy See (Vatican City State), Iran, Islamic Republic of, Isle of Man, Jersey, Kiribati, Korea, Democratic People's Republic of, Lao People's Democratic Republic, Liberia, Libyan Arab Jamahiriya, Liechtenstein, Macedonia, The former Yugoslav Republic of, Malawi, Maldives, Marshall Islands, Martinique, Micronesia, Federated States of, Zimbabwe, Monaco, Montserrat, Myanmar, Nauru, New Caledonia, Niue, Norfolk Island, Northern Mariana Islands, Palau, Palestinian Territory, Occupied, Papua New Guinea, Pitcairn, Reunion, Rwanda, Saint Kitts and Nevis, Saint Lucia, Saint Vincent and The Grenadines, Samoa, San Marino, Sao Tome and Principe, Seychelles, Sierra Leone, Sint Maarten (Dutch Part), Solomon Islands, Somalia, South Georgia and The South Sandwich Islands, South Sudan, Sudan, Syrian Arab Republic, Taiwan, Province of China, Tanzania, United Republic of, Timor-Leste, Tokelau, Tonga, Turks and Caicos Islands, Tuvalu, Venezuela, Bolivarian Republic of, VietNam, Virgin Islands, British, Virgin Islands, U.S., Western Sahara, Yemen",
        },
        {
            question: 'What are conditions for registration to be counted?',
            answer: "We pay for SOI registrations. Credit card is not required!",
        },
    ];

    return JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: questions.map((item, index) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
            },
            position: index + 1, // Add position for each question
        })),
    });
}

export default function Faq() {
    React.useEffect(() => {
        // Create and append the JSON-LD script tag to the head of the document
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.innerHTML = generateStructuredData();
        document.head.appendChild(script);

        // Clean up the script tag on component unmount
        return () => {
            document.head.removeChild(script);
        };
    }, []);

    const {t} = useTranslation();

    const ref1 = React.useRef(null);

    const accordion = React.useRef(null);

    const isInViewport1 = useIsInViewport(ref1);

    const [appeared1, setAppeared1] = React.useState(false);

    const [height, setHeight] = React.useState(500);

    React.useEffect(() => {
        if (isInViewport1) {
            setAppeared1(true);
        }
    }, [isInViewport1])

    const handleScrollTo = React.useCallback((pos) => {
        // if (pos === 'top') {
        //     window.scrollTo({ behavior: 'smooth', top: 0 });
        //     return;
        // }

        // const elem = document.getElementById(pos);
        // if (elem) {
        //     elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" })
        // }
        // return;
    }, []);

    const resize = () => {
        setTimeout(() => {
            if (accordion?.current)
                setHeight(accordion.current.offsetHeight / 1.6);
        }, 150);
    };

    React.useEffect(() => {
        if (accordion?.current)
            setHeight(accordion.current.offsetHeight / 1.6);
    }, [accordion]);

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }, []);

    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://money.warehouse-x.io/faq"/>
                <title>Promote on Affiliate Program – Earn With Warehouse X Now!</title>
            </Helmet>
            <Box id="head" className="background"
                 sx={{
                     backgroundPosition: {xs: '60% 70%', sm: '50% 70%', md: '30% 70%', lg: '0 70%'},
                     backgroundSize: 'cover',
                     backgroundImage: 'url(' + bg1 + ')',
                     boxShadow: {
                         xs: 'inset 0 210px 350px rgb(0 0 0 / 100%)',
                         sm: 'inset 0 180px 190px rgb(0 0 0 / 100%)',
                         md: 'inset 0 130px 150px rgb(0 0 0 / 80%)',
                         lg: 'inset 0 130px 150px rgb(0 0 0 / 80%)'
                     }
                 }}>
                <Container maxWidth="xl">
                    <Header/>
                    <Box
                        ref={ref1}
                        className="container flex column content-center"
                        sx={{
                            minHeight: '90vh',
                            position: 'relative',
                            pt: {xs: '0', sm: '0', md: '180px', lg: '180px'}
                        }}>


                    </Box>
                </Container>
            </Box>
            <Box id="faq" className="background"
                 sx={{
                     position: 'relative',
                     height: height,
                     minHeight: '500px'
                 }}>
                <Container maxWidth="xl">
                    <Box className="container flex column center">
                        <Box ref={accordion} className="flex column" sx={{
                            maxWidth: '815px',
                            background: '#000',
                            p: 1.5,
                            borderRadius: '10px',
                            position: 'absolute',
                            top: '-700px'
                        }}>
                            <Box className="flex column" sx={{p: 3, pb: 6, gap: '5px'}}>
                                <Typography variant="h1" sx={{fontSize: '30px !important', mb: 1}}
                                            className="typography bold third lg">{t("FAQ")}</Typography>
                                <Typography variant="body1" className="typography semibold">
                                    {t("Get your questions answered here or contact us via")}
                                    <a className="color primary" href="mailto:affiliate@warehouse-x.io"
                                       style={{marginLeft: '5px'}}>{t("affiliate@warehouse-x.io")}</a>
                                </Typography>
                            </Box>
                            <Box className="flex accordions" sx={{gap: '20px 24px', flexWrap: 'wrap'}}>
                                <Accordion onChange={resize} disableGutters className="accord">
                                    <AccordionSummary
                                        expandIcon={<Plus/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography variant="body1"
                                                    className="typography semibold">{t("What is X-Money?")}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography ariant="body1" className="typography semibold">
                                            {t("X-Money is the affiliate program behind warehouse-x.io. Warehouse X is a fast-growing online adult reality show with some of the world's most beautiful models. Warehouse X lets members watch and interact with models living in Warehouse X studio.")}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion onChange={resize} disableGutters className="accord">
                                    <AccordionSummary
                                        expandIcon={<Plus/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography variant="body1"
                                                    className="typography semibold">{t("What are the program options?")}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography ariant="body1" className="typography semibold">
                                            {t("Currently we offer RevShare program where you get up to 20.00% of what your users spend, for life*! Send sales to")}
                                            <a className="color primary" href="https://warehouse-x.io"
                                               style={{marginRight: '5px'}}>https://warehouse-x.io</a>{t("and get paid as the members you referred spend more. The earnings just keep coming, it is a great stable deal.")}
                                        </Typography>
                                        <i>
                                            <Typography ariant="body1" className="typography semibold" sx={{mt: 2}}>
                                                {t("*This rule will apply as long as there is an effective X-Money Services Agreement between you (as Affiliate) and the Company.")}
                                            </Typography>
                                        </i>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion onChange={resize} disableGutters className="accord">
                                    <AccordionSummary
                                        expandIcon={<Plus/>}
                                        aria-controls="panel3a-content"
                                        id="panel3a-header"
                                    >
                                        <Typography variant="body1"
                                                    className="typography semibold">{t("How much will I earn?")}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography ariant="body1" className="typography semibold">
                                            {t("The potential is limitless and depends totally on you. The more traffic you send, the more money you make.")}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion onChange={resize} disableGutters className="accord">
                                    <AccordionSummary
                                        expandIcon={<Plus/>}
                                        aria-controls="panel4a-content"
                                        id="panel4a-header"
                                    >
                                        <Typography variant="body1"
                                                    className="typography semibold">{t("How will I know how much I have earned?")}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography ariant="body1" className="typography semibold">
                                            {t("You will be able to login into our affiliate area to view real time stats for your affiliate account.")}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion onChange={resize} disableGutters className="accord">
                                    <AccordionSummary
                                        expandIcon={<Plus/>}
                                        aria-controls="panel5a-content"
                                        id="panel5a-header"
                                    >
                                        <Typography variant="body1"
                                                    className="typography semibold">{t("Where do I start?")}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography ariant="body1" className="typography semibold">
                                            {t("Start making money with X-Money in three simple steps:")}
                                        </Typography>
                                        <List>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <FiberManualRecordIcon fontSize='xsmall'/>
                                                </ListItemIcon>
                                                <Typography ariant="body1"
                                                            className="typography">{t("Register with the X-Money affiliate program;")}</Typography>
                                            </ListItem>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <FiberManualRecordIcon fontSize='xsmall'/>
                                                </ListItemIcon>
                                                <Typography ariant="body1"
                                                            className="typography">{t("Wait until our support team review your submission and activate your account (you will get a confirmation email);")}</Typography>
                                            </ListItem>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <FiberManualRecordIcon fontSize='xsmall'/>
                                                </ListItemIcon>
                                                <Typography ariant="body1"
                                                            className="typography">{t("Start sending traffic;")}</Typography>
                                            </ListItem>
                                        </List>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion onChange={resize} disableGutters className="accord">
                                    <AccordionSummary
                                        expandIcon={<Plus/>}
                                        aria-controls="panel7a-content"
                                        id="panel7a-header"
                                    >
                                        <Typography variant="body1"
                                                    className="typography semibold">{t("When do I get paid?")}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography ariant="body1" className="typography semibold">
                                            {t("Payments are made every Friday for the previous week (from Monday to Sunday).")}
                                        </Typography>
                                        <Typography ariant="body1" className="typography semibold" sx={{mt: 2}}>
                                            {t("A minimum of $200 must be earned during the period, or the money earned will be paid out when the minimum amount has been met.")}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                {/* <Accordion onChange={resize} disableGutters className="accord">
                  <AccordionSummary
                    expandIcon={<Plus />}
                    aria-controls="panel6a-content"
                    id="panel6a-header"
                  >
                    <Typography variant="body1" className="typography semibold">{t("What promotional tools are available?")}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography ariant="body1" className="typography semibold">
                      {t("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.")}
                    </Typography>
                  </AccordionDetails>
                </Accordion> */}

                                <Accordion onChange={resize} disableGutters className="accord">
                                    <AccordionSummary
                                        expandIcon={<Plus/>}
                                        aria-controls="panel7a-content"
                                        id="panel7a-header"
                                    >
                                        <Typography variant="body1"
                                                    className="typography semibold">{t("Do I need multiple accounts for many websites?")}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography ariant="body1" className="typography semibold">
                                            {t("No, you only need one X-Money account. X-Money lets you track signups from all your websites.")}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion onChange={resize} disableGutters className="accord">
                                    <AccordionSummary
                                        expandIcon={<Plus/>}
                                        aria-controls="panel7a-content"
                                        id="panel7a-header"
                                    >
                                        <Typography variant="body1"
                                                    className="typography semibold">{t("Where can I find the referral link?")}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography ariant="body1" className="typography semibold">
                                            {t("You'll find it in the Linking Codes section of the X-Money affiliate area. It is marked as Webmaster Referral URL.")}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion onChange={resize} disableGutters className="accord">
                                    <AccordionSummary
                                        expandIcon={<Plus/>}
                                        aria-controls="panel7a-content"
                                        id="panel7a-header"
                                    >
                                        <Typography variant="body1"
                                                    className="typography semibold">{t("Didn’t find an answer to my question")}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography ariant="body1" className="typography semibold">
                                            {t("No problem! Get in touch with our affiliates support via")}
                                            <a className="color primary" href="mailto:affiliate@warehouse-x.io"
                                               style={{marginLeft: '5px'}}>affiliate@warehouse-x.io</a>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion onChange={resize} disableGutters className="accord">
                                    <AccordionSummary
                                        expandIcon={<Plus/>}
                                        aria-controls="panel7a-content"
                                        id="panel7a-header"
                                    >
                                        <Typography variant="body1"
                                                    className="typography semibold">{t("How much will I earn for a signup of a user?")}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
                                            <Grid>
                                                <Typography ariant="body1" className="typography semibold" sx={{mt: 2}}>
                                                    {t("Tier 1 - $2")}
                                                </Typography>
                                                <Divider/>
                                                <Typography ariant="body1" className="typography semibold" sx={{mt: 2}}>
                                                    {t("Australia, Austria, Belgium, Canada, Denmark, Finland, France, Germany, Ireland, Italy, Luxembourg, Netherlands, New Zealand, Norway, Spain, Sweden, Switzerland, United Kingdom, United States of America")}
                                                </Typography>
                                            </Grid>
                                            <Grid>
                                                <Typography ariant="body1" className="typography semibold" sx={{mt: 2}}>
                                                    {t("Tier 2 - $1")}
                                                </Typography>
                                                <Divider/>
                                                <Typography ariant="body1" className="typography semibold" sx={{mt: 2}}>
                                                    {t("Andorra, Argentina, Bahamas, Belarus, Bolivia, Bosnia and Herzegovina, Brazil, Brunei, Bulgaria, Chile, China, Colombia, Costa Rica, Croatia, Cyprus, Czech Republic, Dominican Republic, Ecuador, Egypt, Estonia, Fiji, Greece, Guyana, Hong Kong, Hungary, Iceland, Indonesia, Israel, Japan, Kazakhstan, Latvia, Lithuania, Macao, Malaysia, Malta, Mexico, Montenegro, Morocco, Nepal, Oman, Panama, Paraguay, Peru, Philippines, Poland, Portugal, Puerto Rico, Qatar, Republic of Korea (South), Romania, Russian Federation, Saudi Arabia, Serbia, Singapore, Slovakia, Slovenia, South Africa, Thailand, Turkey, Ukraine, United Arab Emirates, Uruguay, Vanuatu")}
                                                </Typography>
                                            </Grid>
                                            <Grid>
                                                <Typography ariant="body1" className="typography semibold" sx={{mt: 2}}>
                                                    {t("Tier 3 - $0.5")}
                                                </Typography>
                                                <Divider/>
                                                <Typography ariant="body1" className="typography semibold" sx={{mt: 2}}>
                                                    {t("Albania, Algeria, Angola, Armenia, Azerbaijan, Bahrain, Bangladesh, Barbados, Belize, Benin, Botswana, Burkina Faso, Burundi, Cambodia, Cameroon, Cape Verde, Chad, Comoros, Congo, El Salvador, Ethiopia, Gabon, Georgia, Guatemala, Guinea, Haiti, Honduras, India, Iraq, Jamaica, Jordan, Kenya, Kuwait, Kyrgyzstan, Laos, Lebanon, Lesotho, Macedonia, Madagascar, Mali, Mauritania, Mauritius, Moldova, Mongolia, Mozambique, Namibia, Nicaragua, Niger, Nigeria, Pakistan, Senegal, Sri Lanka, Suriname, Swaziland, Tajikistan, Tanzania, Togo, Trinidad and Tobago, Tunisia, Turkmenistan, Uganda, Uzbekistan, Vietnam, Zambia")}
                                                </Typography>
                                            </Grid>
                                            <Grid>
                                                <Typography ariant="body1" className="typography semibold" sx={{mt: 2}}>
                                                    {t("Tier 4 - $0.1")}
                                                </Typography>
                                                <Divider/>
                                                <Typography ariant="body1" className="typography semibold" sx={{mt: 2}}>
                                                    {t("Afghanistan, Aland Islands, American Samoa, Anguilla, Antigua and Barbuda, Aruba, Bermuda, Bhutan, British Indian Ocean Territory, Brunei Darussalam, Cayman Islands, Central African Republic, Christmas Island, Cocos (Keeling) Islands, Congo, The Democratic Republic of the, Cook Islands, Cote d'Ivoire, Cuba, Curacao, Djibouti, Dominica, Equatorial Guinea, Eritrea, Falkland Islands (Malvinas), Faroe Islands, French Polynesia, French Southern Territories, Gambia, Ghana, Gibraltar, Greenland, Grenada, Guam, Guernsey, Guinea-Bissau, Holy See (Vatican City State), Iran, Islamic Republic of, Isle of Man, Jersey, Kiribati, Korea, Democratic People's Republic of, Lao People's Democratic Republic, Liberia, Libyan Arab Jamahiriya, Liechtenstein, Macedonia, The former Yugoslav Republic of, Malawi, Maldives, Marshall Islands, Martinique, Micronesia, Federated States of, Zimbabwe, Monaco, Montserrat, Myanmar, Nauru, New Caledonia, Niue, Norfolk Island, Northern Mariana Islands, Palau, Palestinian Territory, Occupied, Papua New Guinea, Pitcairn, Reunion, Rwanda, Saint Kitts and Nevis, Saint Lucia, Saint Vincent and The Grenadines, Samoa, San Marino, Sao Tome and Principe, Seychelles, Sierra Leone, Sint Maarten (Dutch Part), Solomon Islands, Somalia, South Georgia and The South Sandwich Islands, South Sudan, Sudan, Syrian Arab Republic, Taiwan, Province of China, Tanzania, United Republic of, Timor-Leste, Tokelau, Tonga, Turks and Caicos Islands, Tuvalu, Venezuela, Bolivarian Republic of, VietNam, Virgin Islands, British, Virgin Islands, U.S., Western Sahara, Yemen")}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion onChange={resize} disableGutters className="accord">
                                    <AccordionSummary
                                        expandIcon={<Plus/>}
                                        aria-controls="panel7a-content"
                                        id="panel7a-header"
                                    >
                                        <Typography variant="body1"
                                                    className="typography semibold">{t("What are conditions for registration to be counted?")}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography ariant="body1" className="typography semibold">
                                            {t(" We pay for SOI registrations. Credit card is not required!")}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Box>
            <Box id="footer" className="background">
                <Container maxWidth="lg">
                    <Box className="container flex items-center"
                         sx={{
                             minHeight: '250px',
                             overflow: 'hidden',
                             flexDirection: {xs: 'column', sm: 'column', md: 'unset', lg: 'unset'},
                             justifyContent: {xs: 'space-evenly', sm: 'space-evenly', md: 'unset', lg: 'unset'},
                         }}
                    >
                        <Box className="flex items-center text-center"
                             sx={{
                                 gap: '70px',
                                 padding: {xs: '15px', sm: '10px', md: '0', lg: '0'}
                             }}>
                            <Link to="/faq">
                                <Typography variant='body1' className="typography color white bold">
                                    {t("FAQ")}
                                </Typography>
                            </Link>
                            <Link to="/">
                                <Typography variant='body1' className="typography color white bold">
                                    {t("TERMS OF SERVICE")}
                                </Typography>
                            </Link>
                            <Link to="/">
                                <Typography variant='body1' className="typography color white bold">
                                    {t("SUPPORT")}
                                </Typography>
                            </Link>
                        </Box>

                        <Box sx={{flexGrow: {xs: 0, sm: 0, md: 1, lg: 1}}}/>

                        <Box sx={{flexGrow: 0}}>
                            <Link to="/" onClick={handleScrollTo('top')}>
                                <img src={logo} alt={t("Logo")} style={{width: '178px'}}/>
                            </Link>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </>
    )
}

function useIsInViewport(ref) {
    const [isIntersecting, setIsIntersecting] = React.useState(false);

    const observer = React.useMemo(
        () =>
            new IntersectionObserver(([entry]) =>
                setIsIntersecting(entry.isIntersecting),
            ),
        [],
    );

    React.useEffect(() => {
        observer.observe(ref.current);

        return () => {
            observer.disconnect();
        };
    }, [ref, observer]);

    return isIntersecting;
}
